import React from 'react';
import {MdCheckbox, MdTextField} from 'core/components/fields/fields';
import {createForm, fieldStyles} from 'core/form/createForm';
import {FormProps, lovLabel, lovValue} from 'core/form/formUtils';
import {BlockComp} from 'core/components/blockComp/blockComp';
import {Validate} from 'core/form/validate';
import {observer} from "mobx-react";
import {Shipment, SHIPMENTDIRECTION, SHIPMENTSTATUS, ShipmentVisit, SHIPMENTVISITSTEP} from "shipment/shipmentDomain";
import Form, {FIELDDEFSIZE} from "core/form/form";
import {action, observable} from "mobx";
import {loc} from "core/common/config/locales";
import StyledSelect from 'core/components/fields/styledSelect';
import {optionsSearch} from "core/common/service/commonDataService";
import MdField, {VALUESOURCETYPE} from 'core/metamodel/mdField';
import {blue500, blueGrey100, grey400, grey500, grey900, red500} from "material-ui/styles/colors";
import {SecuredZzFlatButton, SecuredZzRaisedButton} from "core/components/buttons/buttons";
import {PERMISSION, SECURABLE} from "core/metamodel/metaConstant";
import {ADDRESSPLACETYPE, PARTYROLE} from "party/partyDomain";
import securityService from "core/security/securityService";
import RadioButtonField from "core/components/fields/radioButtonField";
import {LovItem} from "core/metamodel/mdEntity";
import FlatButton from "material-ui/FlatButton";
import GridComp, {UILOCATION} from "core/grid/component/gridComp";
import mdEntityService from "core/metamodel/mdEntityService";
import shipmentService from "shipment/shipmentService";
import {formatDateIso} from "core/common/utils/dateUtils";
import Grid, {FILTEROPERATOR, GridRow} from "core/grid/domain/grid";
import SelectSearchDialog from "core/components/fields/selectSearchDialog";
import GridConfigCondition from "core/grid/domain/gridConfigCondition";
import {ShipmentVisitStepper} from "shipment/component/shipmentVisitComps";
import StyledDatePicker from "core/components/fields/styledDatePicker";
import uiService from "core/common/service/uiService";
import {CountryPhoneFormat, IsRequired} from "core/form/rules";
import {PHONE_PATTERN} from "core/common/utils/constant";
import {ShipmentVisitClosedContent} from "shipment/component/shipmentVisitDriverForm";
import SvgEdit = require('react-icons/lib/md/edit');
import SvgClear = require('react-icons/lib/md/clear');

interface ShipmentVisitPrepareFormProps extends FormProps<ShipmentVisit, ShipmentVisit> {
  // handleShipmentSearch: () => void;
}

const visitNewShipmentGridLocation = 'visitNewShipmentList';


@createForm({
  formName: 'ShipmentVisitPrepareForm',
  fields: [

    {
      name: 'registrationNumber',
      validators: ['IsRequired'],
      size: FIELDDEFSIZE.big
    }, {
      name: 'driverPhone',
      size: FIELDDEFSIZE.big
    }, {
      name: 'visitTime'
    }, {
      name: 'visitEnd'
    }, {
      name: "directionPackaging"
    }, {
      name: "$supplierId",
      mdField: new MdField({valueSourceType: VALUESOURCETYPE.ASYNC}),
      size: FIELDDEFSIZE.big
    }, {
      name: "packagingSender",
      size: FIELDDEFSIZE.big
    }, {
      name: "entranceTime"
    }]
}, undefined)
@observer
export default class ShipmentVisitPrepareForm extends React.Component<ShipmentVisitPrepareFormProps, undefined> {

  private selectSearchDialogRef: SelectSearchDialog;
  @observable private placeOptions: LovItem[];

  selectSearchDialogRefHandler = (comp) => this.selectSearchDialogRef = comp;

  componentWillMount() {
    let {dataObject} = this.props;
    this.setPlus(dataObject);
    dataObject.$shipmentVisitShipmentsGrid.showSelection = true;
  }

  componentDidMount() {
    return optionsSearch('AddressPlace', {
      partyId: securityService.currentTenant.party.value,
      placeType: ADDRESSPLACETYPE.EXPEDITION
    }).then(({options: placeOptions}) => {
      placeOptions.unshift({value: null, label: '---'});
      this.placeOptions = placeOptions;
    })
  }

  componentDidUpdate(prevProps: Readonly<ShipmentVisitPrepareFormProps>, prevState: Readonly<undefined>, prevContext: any) {
    this.setPlus(this.props.dataObject);
    this.props.dataObject.$shipmentVisitShipmentsGrid.showSelection = true;
  }


  @action setPlus(dataObject: ShipmentVisit) {
    if (!dataObject.driverPhone && [SHIPMENTVISITSTEP.VEHICLE_ARRIVED, SHIPMENTVISITSTEP.VEHICLE_ENTERED].includes(lovValue(dataObject.step))) {
      dataObject.driverPhone = "+";
      this.props.form.updateFieldsPropValue(dataObject, "driverPhone");
    }
  }


  render() {

    let {dataObject, rootObject, entity, entities, form, formName, disabled} = this.props;
    let {
      registrationNumber, directionPackaging, visitTime, visitEnd, $supplierId, packagingSender, entranceTime, driverPhone
    } = dataObject.getFormFields(formName);

    console.log("Rendering ShipmentVisitPrepareForm, shipments count %s", (dataObject.shipments) ? dataObject.shipments.length : 0);


    let updateRight = securityService.hasRight(SECURABLE.shipmentVisitDetail.name, PERMISSION.Update);

    let shipmentdirectionEntity = entities.get("SHIPMENTDIRECTION");
    let shipmentVisitStepEntity = entities.get("SHIPMENTVISITSTEP");
    //let activeStepNumber = shipmentVisitStepLovs.map(lov => lov.value).indexOf(lovValue(dataObject.step));


    const showSyncSpz = dataObject.shipments && !!dataObject.shipments.some(sh => sh.registrationNumber !== dataObject.registrationNumber) && !disabled;
    const showSyncStatus = dataObject.shipments && !!dataObject.shipments.length && [SHIPMENTVISITSTEP.PREPARED_VISIT, SHIPMENTVISITSTEP.VEHICLE_ARRIVED, SHIPMENTVISITSTEP.VEHICLE_ENTERED, SHIPMENTVISITSTEP.VEHICLE_LEFT].includes(lovValue(dataObject.step)) && !disabled;

    return (

      <form style={{marginTop: 10}} autoComplete="off">

        <BlockComp>
          <SelectSearchDialog ref={this.selectSearchDialogRefHandler} gridLocation="shipmentSearch" showGridConfig={true} title="Add Shipments" showOk/>
          <ShipmentVisitStepper dataObject={dataObject} entities={entities}/>


          {/* ************  DIRECTION  *************/}
          {
            (lovValue(dataObject.step) === SHIPMENTVISITSTEP.PREPARED_VISIT) && (
              <div className="row">
                <div className="col-xs-12">
                  <RadioButtonField value={dataObject.$direction} onChange={this.handleDirectionChange} options={shipmentdirectionEntity.lovItems} disabled={disabled}
                                    style={{marginTop: 20}}
                                    groupStyle={{display: 'flex', height: 50, justifyContent: "center"}}
                                    optionStyle={{width: 'initial', marginRight: 15, fontSize: 25, height: 40}}
                                    labelStyle={{whiteSpace: 'nowrap', marginLeft: -10}}
                                    iconStyleFn={v => ({fill: v === SHIPMENTDIRECTION.OUTGOING ? blue500 : red500, height: 30, width: 30})}/>
                </div>
              </div>
            )
          }

          {
            (lovValue(dataObject.step) !== SHIPMENTVISITSTEP.PREPARED_VISIT) && (
              <div className="row">
                <div className="fx col-xs-12" style={{justifyContent: "center"}}>
                  <span style={{fontSize: 25, color: grey500}}>{lovLabel(dataObject.$direction)} {loc.i18n`Visit`} </span>
                </div>
              </div>
            )}

          {/* ************  SPZ  *************/}
          {dataObject.$direction && (
            <div className="row">
              <div className="fx col-xs-6 col-sm-3">
                <MdTextField {...registrationNumber.props} floatingLabelFixed={true} disabled={disabled}
                             floatingLabelStyle={{...registrationNumber.props.floatingLabelStyle, fontSize: 25, top: 25, color: grey900}} autoComplete="off"/>
                <Validate field={registrationNumber} value={registrationNumber.props.value} onSuccess={this.handleRegistrationNumberSuccess} dataObject={dataObject}/>
              </div>
              <div className="fx col-xs-12 col-sm-6">
                {!disabled && <FlatButton label={loc.i18n`Find shipments`} primary onClick={this.findShipmentsSpz} disabled={!registrationNumber.valid} style={{alignSelf: "flex-end"}} labelStyle={{fontSize: 16}}/>}
                {!disabled && (
                  <div style={{display: "flex"}}>
                    <FlatButton label={loc.i18n`Add shipments manually`} primary onClick={this.addShipments} style={{alignSelf: "flex-end"}} labelStyle={{fontSize: 16}}/>
                  </div>
                )}
              </div>
              {!dataObject.$new &&
                <div className="fx col-xs-12 col-sm-3">
                  <MdTextField {...driverPhone.props} floatingLabelFixed={true} floatingLabelStyle={{...driverPhone.props.floatingLabelStyle, fontSize: 25, top: 25, color: grey900}} disabled={disabled}
                               autoComplete="off"/>
                  <Validate field={driverPhone} value={driverPhone.props.value} dataObject={dataObject}>
                    <CountryPhoneFormat pattern={PHONE_PATTERN}/>
                    <IsRequired condition={[SHIPMENTVISITSTEP.VEHICLE_ARRIVED, SHIPMENTVISITSTEP.VEHICLE_ENTERED].includes(lovValue(dataObject.step))}/>
                  </Validate>
                </div>}
            </div>
          )}

          {/* ************  PACKAGING & SENDER  *************/}
          {(lovValue(dataObject.$direction) === SHIPMENTDIRECTION.OUTGOING) && (
            <div className="row">
              <div className="fx col-xs-12">
                <MdCheckbox {...directionPackaging.props} onCheck={this.handleDirectionPackaging} disabled={disabled}
                            style={{height: 30, width: 'auto', marginRight: 20, marginTop: 20}} labelStyle={{whiteSpace: 'nowrap', fontSize: 16, color: grey900}}/>
              </div>
              {
                (dataObject.directionPackaging) && (
                  <div className="fx col-xs-12 col-sm-6">
                    <StyledSelect {...packagingSender.props} disabled={disabled}
                                  async={true} clearable={true} asterixForAll floatingLabelText="."
                                  loadOptions={optionsSearch.bind(this, lovValue('Party'), {role: [PARTYROLE.PACKAGING]})}/>
                    <Validate field={packagingSender} value={packagingSender.props.value}/>
                  </div>
                )
              }
            </div>
          )}

          {/* ************  SUPPLIER  *************/}
          {(lovValue(dataObject.$direction) === SHIPMENTDIRECTION.INCOMING) && (
            <div className="row">
              <div className="fx col-xs-4">
                <div style={{width: "100%", marginTop: 5}}>
                  <span style={{fontSize: 18, color: grey900, position: "relative", top: 15, zIndex: 2}}>Supplier</span>
                  <StyledSelect {...$supplierId.props} floatingLabelText="." disabled={disabled}
                                async={true} clearable={true} asterixForAll floatingLabelStyle={{...$supplierId.props.floatingLabelStyle, fontSize: 1, color: 'white'}}
                                loadOptions={optionsSearch.bind(this, "Shipment", {potentialSuppliers: true})}/>
                </div>
              </div>
              <div className="fx col-xs-3">
                {!disabled && <FlatButton label={loc.i18n`Find shipments`} primary onClick={this.findShipmentsSupplier} disabled={!$supplierId.props.value} style={{alignSelf: "flex-end"}}
                                          labelStyle={{fontSize: 16}}/>}
              </div>
            </div>
          )}

          {(showSyncSpz || showSyncStatus) &&
            <div className="row">
              <div className="fx col-xs-12">
                <span style={{fontSize: 20, marginTop: 20, color: grey400}}>{loc.i18n`Synchronize data on linked shipments`}</span>
              </div>
            </div>
          }

          {/* ************  SYNC SPZ  *************/}
          {showSyncSpz && (
            <div className="row">
              <div className="fx col-xs-12">
                <MdCheckbox checked={dataObject.$syncRegistrationNumber} onCheck={this.handleSyncSpz} label={loc.i18n`Update Registration number`}
                            style={{height: 30, width: 'auto', marginRight: 20, marginTop: 20}} labelStyle={{whiteSpace: 'nowrap', fontSize: 16, color: grey900}}/>
              </div>
            </div>
          )}

          {/* ************  SYNC SHIPMENT STATUS  *************/}
          {showSyncStatus && (
            <div className="row">
              <div className="fx col-xs-12">

                <MdCheckbox name="allReadyCK" checked={lovValue(dataObject.$syncShipmentStatus) === SHIPMENTSTATUS.READY}
                            label="Vše připraveno" onCheck={this.onCheckAllReady}
                            style={{height: 30, width: 'auto', marginRight: 20, marginTop: 20}} labelStyle={{whiteSpace: 'nowrap', fontSize: 16, color: grey900}}/>
                <MdCheckbox name="partaillyReadyCK" checked={lovValue(dataObject.$syncShipmentStatus) === SHIPMENTSTATUS.PARTIALLYREADY}
                            label="Částečně připraveno" onCheck={this.onCheckPartiallyReady}
                            style={{height: 30, width: 'auto', marginRight: 20, marginTop: 20}} labelStyle={{whiteSpace: 'nowrap', fontSize: 16, color: grey900}}/>
                <MdCheckbox name="documentCK" checked={lovValue(dataObject.$syncShipmentStatus) === SHIPMENTSTATUS.DOCUMENT}
                            label="Dokument" onCheck={this.onCheckDocument}
                            style={{height: 30, width: 'auto', marginRight: 20, marginTop: 20}} labelStyle={{whiteSpace: 'nowrap', fontSize: 16, color: grey900}}/>
              </div>
            </div>
          )}

          {/* ************  SYNC SHIPMENT EXPEDIITON PLACE (shippedFromPlace)  *************/}
          {showSyncStatus && (
            <div className="row">
              <div className="fx col-xs-12">
                <span style={{alignSelf: "flex-end", marginRight: 10, fontSize: 18}}>{entities.get("Shipment").getField("shippedFromPlace").formLabelActive}</span>
                <StyledSelect {...fieldStyles.big.styledSelect} name="syncShippedFromPlace" value={dataObject.$syncShippedFromPlace} options={this.placeOptions} onChange={this.handleSyncShippedFromPlace} clearable={false}/>
              </div>
            </div>
          )}


          {/* ************  SHIPMENT GRID  *************/}
          {dataObject.$direction && (
            <div style={{marginTop: 20}}>
              <GridComp ref={visitNewShipmentGridLocation}
                        grid={dataObject.$shipmentVisitShipmentsGrid}
                        uiLocation={UILOCATION.main}
                        entities={mdEntityService.entityMap}
                        rootObject={dataObject}
                        showDelete={true}
                        deleteRowIcon="fa fa-trash" disableDeleteFn={(sh: Shipment) => disabled}
                        editOverrideFn={this.gridDeleteOverrideFn}
                        hideToolbar/>
            </div>
          )}


          {/* ************  SHIPMENT VISITS TO DELETE  *************/}
          {dataObject.$visitsToDelete && !!dataObject.$visitsToDelete.length &&
            <div className="row">
              <div className="fx col-xs-12">
                <span style={{fontSize: 20, color: grey400}}>Merged visits to delete</span>
              </div>
            </div>
          }
          {dataObject.$visitsToDelete && !!dataObject.$visitsToDelete.length &&
            <div className="row" style={{marginBottom: 30}}>
              <div className="fx col-xs-12">
                {dataObject.$visitsToDelete.map(visit => (
                  <ShipmentVisitClosedContent dataObject={visit} entities={entities}
                                              entity={entity}
                                              fields={new Form("ShipmentVisitDriverForm", mdEntityService.getFormDefinition("ShipmentVisitDriverForm")).setupFields(visit, visit, entity, entities, null)}/>
                ))}
              </div>
            </div>
          }


          {/* ************  BUTTONS  *************/}
          {(dataObject.$direction && lovValue(dataObject.step) === SHIPMENTVISITSTEP.PREPARED_VISIT) && dataObject.$new && !disabled && (
            <div className="row" style={{marginTop: 10}}>
              <SecuredZzRaisedButton onClick={this.onSave}
                                     label={loc.i18n`Create prepared visit`}
                                     disabled={!registrationNumber.valid || !dataObject.$dirty}
                                     permission={PERMISSION.New}
                                     secondary={true} style={{height: 60}} labelStyle={{fontSize: 20}}/>
            </div>
          )}

          {(!dataObject.$new && lovValue(dataObject.step) === SHIPMENTVISITSTEP.PREPARED_VISIT) && !disabled && (
            <div className="row" style={{marginTop: 10, display: "flex"}}>
              <SecuredZzFlatButton label={loc.i18n`Update visit`} disabled={uiService.getToolbarActionFlag()} onClick={this.onSave} permission={PERMISSION.Update}
                                   primary={true} style={{height: 60, width: 200, marginRight: 10}} labelStyle={{fontSize: 20}}/>
              <SecuredZzRaisedButton onClick={this.onNextVehicleArrived}
                                     label={shipmentVisitStepEntity.getLovItem(SHIPMENTVISITSTEP.VEHICLE_ARRIVED).label}
                                     disabled={!registrationNumber.valid} securable={SECURABLE.shipmentVisitDetail} permission={PERMISSION.Update}
                                     primary={true} style={{height: 60}} labelStyle={{fontSize: 20}}/>
              <NextTimeComp shipmentVisit={dataObject} label={visitTime.props.floatingLabelText}/>
            </div>
          )}

          {(!dataObject.$new && lovValue(dataObject.step) === SHIPMENTVISITSTEP.VEHICLE_ARRIVED) && !disabled && (
            <div className="row" style={{marginTop: 10, display: "flex"}}>
              <SecuredZzFlatButton label={loc.i18n`Update visit`} disabled={uiService.getToolbarActionFlag()} onClick={this.onSave} permission={PERMISSION.Update}
                                   primary={true} style={{height: 60, width: 200, marginRight: 10}} labelStyle={{fontSize: 20}}/>
              <SecuredZzRaisedButton onClick={this.onNextVehicleEntered}
                                     label={shipmentVisitStepEntity.getLovItem(SHIPMENTVISITSTEP.VEHICLE_ENTERED).label}
                                     disabled={!registrationNumber.valid} securable={SECURABLE.shipmentVisitDetail} permission={PERMISSION.Update}
                                     primary={true} style={{height: 60}} labelStyle={{fontSize: 20}}/>
              <NextTimeComp shipmentVisit={dataObject} label={entranceTime.props.floatingLabelText}/>
              {!disabled && <MdCheckbox checked={dataObject.$showSmsToDriver} onCheck={this.handleShowSmsToDriver} label={loc.i18n`Send SMS to driver`}
                                        style={{width: 'auto', marginLeft: 20, marginRight: 20, alignSelf: "flex-end"}} labelStyle={{whiteSpace: 'nowrap', fontSize: 16, color: grey900, marginLeft: -10}}/>}
              {!disabled && dataObject.$showSmsToDriver &&
                <MdTextField floatingLabelFixed={true} value={dataObject.getTuple("SHIPMENT_GATE_ARRIVAL_TO_DRIVER_SMS_TEXT")} onChange={this.handleSmsToDriverText} autoComplete="off" style={{alignSelf: "flex-end", flexGrow: 1}}/>}
            </div>
          )}

          {(!dataObject.$new && lovValue(dataObject.step) === SHIPMENTVISITSTEP.VEHICLE_ENTERED) && !disabled && (
            <div className="row" style={{marginTop: 10, display: "flex"}}>
              <SecuredZzFlatButton label={loc.i18n`Update visit`} disabled={uiService.getToolbarActionFlag()} onClick={this.onSave} permission={PERMISSION.Update}
                                   primary={true} style={{height: 60, width: 200, marginRight: 10}} labelStyle={{fontSize: 20}}/>
              <SecuredZzRaisedButton onClick={this.onNextVehicleLeft}
                                     label={shipmentVisitStepEntity.getLovItem(SHIPMENTVISITSTEP.VEHICLE_LEFT).label}
                                     disabled={!registrationNumber.valid} securable={SECURABLE.shipmentVisitDetail} permission={PERMISSION.Update}
                                     primary={true} style={{height: 60}} labelStyle={{fontSize: 20}}/>
              <NextTimeComp shipmentVisit={dataObject} label={visitEnd.props.floatingLabelText}/>
            </div>
          )}


        </BlockComp>


      </form>

    )
  }


  @action onSave = (e) => {
    let {dataObject, entities, onSubmit} = this.props;
    return onSubmit(dataObject).then(() => {
      console.log("After onSave shipment statuses: ", shipmentService.shipmentVisitObject.shipments.map(s => lovValue(s.shipmentStatus)).join(", "));
      shipmentService.shipmentVisitObject.$shipmentVisitShipmentsGrid.selectAllRows(false);
      return shipmentService.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService.shipmentVisitObject);
    })
  };

  @action onNextVehicleArrived = (e) => {
    let {dataObject, entities, onSubmit} = this.props;
    return onSubmit(dataObject, () => {
      dataObject.step = entities.get("SHIPMENTVISITSTEP").getLovItem(SHIPMENTVISITSTEP.VEHICLE_ARRIVED);
      dataObject.visitTime = (dataObject.$nextTime) ? dataObject.$nextTime : new Date().toISOString();
      dataObject.$nextTime = undefined;
    }).then(() => {
      shipmentService.shipmentVisitObject.$shipmentVisitShipmentsGrid.selectAllRows(false);
      return shipmentService.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService.shipmentVisitObject);
    });
  };

  @action onNextVehicleEntered = (e) => {
    let {dataObject, entities, onSubmit} = this.props;
    return onSubmit(dataObject, () => {
      dataObject.step = entities.get("SHIPMENTVISITSTEP").getLovItem(SHIPMENTVISITSTEP.VEHICLE_ENTERED);
      dataObject.entranceTime = (dataObject.$nextTime) ? dataObject.$nextTime : new Date().toISOString();
      dataObject.$nextTime = undefined;
      if (!dataObject.$showSmsToDriver) dataObject.setTuple("SHIPMENT_GATE_ARRIVAL_TO_DRIVER_SMS_TEXT", undefined);
    }).then(() => {
      shipmentService.shipmentVisitObject.$shipmentVisitShipmentsGrid.selectAllRows(false);
      return shipmentService.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService.shipmentVisitObject);
    })
  };

  @action onNextVehicleLeft = (e) => {
    let {dataObject, entities, onSubmit} = this.props;
    return onSubmit(dataObject, () => {
      dataObject.step = entities.get("SHIPMENTVISITSTEP").getLovItem(SHIPMENTVISITSTEP.VEHICLE_LEFT);
      dataObject.visitEnd = (dataObject.$nextTime) ? dataObject.$nextTime : new Date().toISOString();
      dataObject.$nextTime = undefined;
    }).then(() => {
      shipmentService.shipmentVisitObject.$shipmentVisitShipmentsGrid.selectAllRows(false);
      return shipmentService.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService.shipmentVisitObject);
    })
  };


  @action handleDirectionChange = (newLov: LovItem<SHIPMENTDIRECTION>) => {
    const {dataObject} = this.props;
    dataObject.$direction = newLov;
    dataObject.directionOutgoing = (lovValue(newLov) === SHIPMENTDIRECTION.OUTGOING);
    dataObject.directionIncoming = (lovValue(newLov) === SHIPMENTDIRECTION.INCOMING);
    dataObject.directionPackaging = false;
    dataObject.$visitsToDelete = [];
    let _prev = dataObject.shipments;
    dataObject.shipments = (dataObject.$previousShipments) ? dataObject.$previousShipments.filter(sh => sh.shipmentDirection === lovValue(newLov)) : [];
    dataObject.$previousShipments = _prev;
    return shipmentService.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService.shipmentVisitObject);
  }

  @action findShipmentsSpz = (evt: any) => {
    const {dataObject, form} = this.props;
    const shipmentDate = formatDateIso(dataObject.dateCreated ? dataObject.dateCreated : new Date());
    return shipmentService.readShipments(dataObject.registrationNumber, shipmentDate, FILTEROPERATOR.LESSOREQUALTHAN, undefined, dataObject.$direction.value, dataObject, false)
      .then(action("readShipments-acb", (shipments: Shipment[]) => {
        dataObject.shipments = shipments;
        dataObject.$syncRegistrationNumber = dataObject.shipments.some(sh => sh.registrationNumber !== dataObject.registrationNumber);
        return shipmentService.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService.shipmentVisitObject);
      }));
  }

  @action findShipmentsSupplier = (evt: any) => {
    const {dataObject, form} = this.props;
    const shipmentDate = formatDateIso(dataObject.dateCreated ? dataObject.dateCreated : new Date());
    return shipmentService.readShipments(undefined, shipmentDate, FILTEROPERATOR.LESSOREQUALTHAN, lovValue(dataObject.$supplierId), dataObject.$direction.value, dataObject, true)
      .then(action("readShipments-acb", (shipments: Shipment[]) => {
        dataObject.shipments = shipments;
        dataObject.$syncRegistrationNumber = dataObject.shipments.some(sh => sh.registrationNumber !== dataObject.registrationNumber);
        return shipmentService.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService.shipmentVisitObject);
      }));
  }

  @action handleDirectionPackaging = (evt) => {
    let {entities, dataObject, form, rootObject} = this.props;
    form.getField("directionPackaging").props.onCheck(evt);
    if (!dataObject.directionPackaging) {
      dataObject.packagingSender = undefined;
      form.updateFieldsPropValue(dataObject, "packagingSender");
    }
  }

  @action handleSyncSpz = (evt: any) => {
    const {dataObject, form} = this.props;
    dataObject.$syncRegistrationNumber = evt.target.checked;
  }

  @action handleRegistrationNumberSuccess = () => {
    const {dataObject} = this.props;
    dataObject.$syncRegistrationNumber = dataObject.shipments.some(sh => sh.registrationNumber !== dataObject.registrationNumber);
  }

  @action handleSyncShippedFromPlace = (value: LovItem<number>) => {
    const {dataObject, form} = this.props;
    dataObject.$syncShippedFromPlace = value;
  }

  @action onCheckAllReady = (evt: any) => {
    const {dataObject, form} = this.props;
    dataObject.$syncShipmentStatus = (evt.target.checked) ? SHIPMENTSTATUS.READY : undefined;
  }
  @action onCheckPartiallyReady = (evt: any) => {
    const {dataObject, form} = this.props;
    dataObject.$syncShipmentStatus = (evt.target.checked) ? SHIPMENTSTATUS.PARTIALLYREADY : undefined;
  }
  @action onCheckDocument = (evt: any) => {
    const {dataObject, form} = this.props;
    dataObject.$syncShipmentStatus = (evt.target.checked) ? SHIPMENTSTATUS.DOCUMENT : undefined;
  }


  @action handleShowSmsToDriver = (evt: any) => {
    const {dataObject} = this.props;
    dataObject.$showSmsToDriver = evt.target.checked;
  }

  @action handleSmsToDriverText = (evt: any) => {
    const {dataObject} = this.props;
    dataObject.setTuple("SHIPMENT_GATE_ARRIVAL_TO_DRIVER_SMS_TEXT", evt.target.value);
  }


  @action addShipments = () => {
    let {dataObject, entity, rootObject, entities} = this.props;
    console.log('addShipments');
    let shipmentEntity = entities.get("Shipment");

    new Promise((resolve, reject) => {
      return this.selectSearchDialogRef.open(resolve, reject, (grid: Grid) => {
        if (!grid.conditionArray) grid.conditionArray = [];
        // vyloucime jiz pridane
        if (dataObject.shipments && dataObject.shipments.length) {
          grid.conditionArray.push(new GridConfigCondition(grid.$gridLocationRef, {
            field: shipmentEntity.getField("shipmentId"),
            operator: FILTEROPERATOR.NOTIN,
            values: dataObject.shipments.map(s => s.shipmentId)
          }));
        }
        // vyloucime podle DIRECTION
        grid.conditionArray.push(new GridConfigCondition(grid.$gridLocationRef, {
          field: shipmentEntity.getField("shipmentDirection"),
          operator: FILTEROPERATOR.EQUAL,
          values: [dataObject.$direction]
        }));
      });
    }).then(action("close-new-party-diaglog", (shipments: Shipment[]) => {
      console.log("adding %o", shipments);
      dataObject.shipments = [...dataObject.shipments || [], ...shipments];
      dataObject.$syncRegistrationNumber = dataObject.shipments.some(sh => sh.registrationNumber !== dataObject.registrationNumber);
      rootObject.$dirty = true;
      return shipmentService.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService.shipmentVisitObject);
    })).catch((e) => {
    });
  };


  @action gridDeleteOverrideFn = (rootObject: ShipmentVisit, modifiedRows: GridRow[], toDeleteRows: GridRow[], params?: { [key: string]: any }): Promise<any> => {
    let {dataObject} = this.props;
    if (toDeleteRows && toDeleteRows.length) {
      let shipmentIds = toDeleteRows.map(v => v.rowId);
      dataObject.shipments = dataObject.shipments.filter(sh => !shipmentIds.includes(sh.shipmentId));
      this.props.rootObject.$dirty = true;
      return shipmentService.shipmentVisitObject.$shipmentVisitShipmentsGrid.search(shipmentService.shipmentVisitObject);
    } else {
      return Promise.resolve(null);
    }

  };


}


type NextTimeCompProps = {
  shipmentVisit: ShipmentVisit;
  label: string;
};

@observer
class NextTimeComp extends React.Component<NextTimeCompProps, any> {

  render() {
    const {shipmentVisit, label} = this.props;
    console.debug("NextTimeComp $nextTime = %s", shipmentVisit.$nextTime);
    return (
      <div style={{marginLeft: 20, display: "flex"}}>
        <span style={{alignSelf: "flex-end", marginRight: 10, fontSize: 18}}>{label}:</span>
        {!shipmentVisit.$nextTime && (
          <div style={{paddingLeft: 10, marginRight: 5, alignSelf: "flex-end", display: "flex", backgroundColor: blueGrey100, borderRadius: 4, overflow: "hidden"}}>
            <span style={{alignSelf: "flex-end", marginRight: 5, fontSize: 18}}>{loc.i18n`Current time`}</span>
            <SvgEdit style={{alignSelf: "flex-end", fontSize: 18}} className="active-item--check" onClick={this.handleEdit}/>
          </div>
        )}
        {shipmentVisit.$nextTime && <StyledDatePicker value={shipmentVisit.$nextTime} onChange={this.handleNextTime} time/>}
        {shipmentVisit.$nextTime && <SvgClear style={{alignSelf: "flex-end", fontSize: 18}} className="active-item--check" onClick={this.handleClear}/>}
      </div>
    )
  }

  @action handleNextTime = (newTime) => {
    const {shipmentVisit} = this.props;
    shipmentVisit.$nextTime = newTime;
    console.log("handleNextTime %s", shipmentVisit.$nextTime);
  }

  @action handleEdit = () => {
    const {shipmentVisit} = this.props;
    shipmentVisit.$nextTime = new Date().toISOString();
    ;
    console.log("handleEdit %s", shipmentVisit.$nextTime);
  }

  @action handleClear = () => {
    const {shipmentVisit} = this.props;
    shipmentVisit.$nextTime = undefined;
    console.log("handleClear %s", shipmentVisit.$nextTime);
  }

}



// WEBPACK FOOTER //
// ./src/shipment/component/shipmentVisitPrepareForm.tsx